import {AfterViewInit, Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {Utils} from "../../../../../../shared/utils/utils";
import {CookieService} from "ngx-cookie";

@Component({
    selector: 'db-create-ai-assistant-template-select',
    templateUrl: './create-ai-assistant-template-select.component.html',
    styleUrls: ['./create-ai-assistant-template-select.component.scss'],
    standalone: false
})
export class CreateAiAssistantTemplateSelectComponent implements OnChanges, AfterViewInit {

  @Input() selectedTemplate = '';
  @Input() selectedTheme = null;
  @Input() templates;
  @Input() themes;
  @Input() theme;
  @Input() imagesLoading: boolean = true;
  @Input() currentStep = 0;
  @Input() stepsLength = 0;
  @Output() back = new EventEmitter<void>();
  @Output() onTemplateSelect = new EventEmitter<string>();
  @Output() onThemeSelect = new EventEmitter<string>();
  @Output() setTemplate = new EventEmitter<string>();
  @Output() setTheme = new EventEmitter<string>();
  public isMobile: boolean;
  public showThemes: boolean;
  public visibility: string|null;
  public counter: number = 0;
  public len: number = 0;
  public hovered: number|null = null;

  constructor(
    private _cookieService: CookieService
  ) {
    this.isMobile = window.innerWidth <= 991;
  }

  ngAfterViewInit () {
    setTimeout(() => {
    this._init();
    }, 1000);
  }

  ngOnChanges() {
    this._init();
  }

  private _init(): void {
    this.checkImagesLoaded();
  }

  public backToPreviousStep(): void {
    this.back.emit();
  }
  public proceedToNextQuestion(): void {
    if (!this.selectedTemplate) return;
    this.onThemeSelect.emit(this.selectedTheme);
    this.onTemplateSelect.emit(this.selectedTemplate);
  }

  public colorToRgba(color, opacity): string {
    return Utils.hexToRgbA(color, opacity);
  }

  public selectThemeWithId(themeId): void {
    this.imagesLoading = true;
    this.selectedTheme = themeId;
    this.setTheme.emit(themeId);
    this.checkImagesLoaded();
  }

  public checkImagesLoaded() {
    if (!this.imagesLoading) return;
    const imgs = document.images;
    this.len = imgs.length;
    this.counter = 0;
    [].forEach.call( imgs, ( img ) => {
      if (img.complete) {
        this.incrementCounter();
      }
      else {
        img.addEventListener( 'load', this.incrementCounter, false );
      }
    } );
  }

  public selectTemplate(template: string) {
    this.selectedTemplate = template;
    this.setTemplate.emit(template);
  }

  public incrementCounter() {
    this.counter++;
    if ( this.counter === this.len ) {
      setTimeout(() => {this.imagesLoading = false}, 300);
    }
  }

}
